import { environment } from "environments/environment";

export class AppSettings {
  public static readonly BaseURL = environment.API_END_POINT; // window.location.origin.replace("8080", "8081") + "/";  //'http://localhost:8081/';
  public static readonly DASHBOARD_END_POINT = environment.DASHBOARD_END_POINT;
  // public static readonly BaseURL = 'http://localhost:8081/'; // window.location.origin.replace("8080", "8081") + "/";  //'http://localhost:8081/';
  public static readonly SocketURL = "http://localhost:10025"; // window.location.origin.replace("8080", "10025") + "/" //'http://localhost:10025';
  //Anomalies
  public static readonly API_ANOMALIES = AppSettings.BaseURL + "anomaly";
  public static readonly API_ANOMALIES_History =
    AppSettings.API_ANOMALIES + "/history";
// auto audit changes,history SHOULD BE CHANGED
  // public static readonly API_ANOMALIES_AUTO_AUDITED = AppSettings.API_ANOMALIES + "/history"; 
  // public static readonly API_ANOMALIES_SUBMIT_AUTO_AUDITS = AppSettings.API_ANOMALIES + "/history"; 
    /*edit/delete option for audited anomalies*/
    public static readonly API_GET_AUDITED_DATA = environment.DASHBOARD_END_POINT + "/AuditPage/auditor/get_audited_data";
  public static readonly API_ANOMALIES_HistoryDates =
    AppSettings.API_ANOMALIES + "/get_history_dates";
  public static readonly API_ANOMALIES_EXPORTFILE =
    AppSettings.API_ANOMALIES + "/exportFile";

   /* updateImage from  an video*/
   public static readonly API_EXTRACT_IMAGE  = AppSettings.DASHBOARD_END_POINT + "/AuditPage/auditor/extract-images";
    /*edit/delete option for audited anomalies*/
    public static readonly UPDATE_AUDITED_ANOMALY = environment.DASHBOARD_END_POINT + "/AuditPage/auditor/update_anomaly";
    public static readonly DELETE_AUDITED_ANOMALY = environment.DASHBOARD_END_POINT + "/AuditPage/auditor/delete_anomaly";
  //Account
  public static readonly API_ACCOUNT_LOGIN =
    AppSettings.BaseURL + "account/login";
  public static readonly API_GET_ORGANIZATIONS =
    AppSettings.BaseURL + "account/organizations";
  public static readonly API_CHECK_FOR_UNPROCESSED_VIDEO =
    AppSettings.BaseURL + "account/check-for-unprocessed-video";
  //Video
  public static readonly getDeletedAudits =
  AppSettings.BaseURL + "asset/getDeletedAudits";
  public static readonly getFalseAnomaly =
  AppSettings.BaseURL + "asset/get-false-Anomaly";
  
  public static readonly API_UNDER_REVIEW_AN_ANOMALY =
  AppSettings.BaseURL + "anomaly/under_review";
  public static readonly API_VIDEO_DELETE =
    AppSettings.BaseURL + "video/delete";
  public static readonly API_VIDEO_STATUS =
    AppSettings.BaseURL + "video/status";
  public static readonly API_VIDEO_UPLOAD =
    AppSettings.BaseURL + "video/upload";
  public static readonly API_VIDEO_DELETE_INPROGRESS =
    AppSettings.BaseURL + "video/delete-in-progress";
  public static readonly API_VIDEO_UPDATE_UNPROCESSED =
    AppSettings.BaseURL + "video/updateUnprocessed";
  public static readonly API_VIDEO_GETDISKSPACE =
    AppSettings.BaseURL + "video/getAvailableDiskSpace";
  //Assets
  public static readonly API_ASSET_ALL = AppSettings.BaseURL + "asset/all";

  // Asset Types
  public static readonly API_ASSET_STATUS =
    AppSettings.DASHBOARD_END_POINT + "/Master/asset_types";
  public static readonly API_ORGANIZATION_SITES =
    AppSettings.DASHBOARD_END_POINT + "/Master/site";
    public static readonly API_BULK_DELETE =
      AppSettings.BaseURL + "bulk/delete";


  //Notifications
  public static readonly API_NOTIFICATION_ALL =
    AppSettings.BaseURL + "notification";
  public static readonly API_NOTIFICATION_VIEWED =
    AppSettings.BaseURL + "notification/viewed";
  public static readonly API_NOTIFICATION_DELETE =
    AppSettings.BaseURL + "notification/delete";

  public static readonly API_DASHBOARD_UPDATE_ANOMALY =
    AppSettings.BaseURL + "auditor/anomaly/update";
  public static readonly API_DASHBOARD_COMPLETE_ANOMALY =
    AppSettings.BaseURL + "auditor/anomaly/completed";

  public static readonly ASSETS =
    AppSettings.DASHBOARD_END_POINT + "/Master/asset_types_in_assets";
  public static readonly GET_VIDEO_NAMES =
    AppSettings.BaseURL + "anomaly/video-list";

  public static VideoUploadStatus;

  public static SetVideoUploadStatus(status) {
    localStorage.setItem("videoUploadStatus", status);
  }

  public static GetVideoUploadStatus() {
    localStorage.getItem("videoUploadStatus");
  }

  public static readonly GET_FALSE_POSITIVE_DATA =
  environment.DASHBOARD_END_POINT + "/AuditPage/auditor/false_positive";

  public static readonly ANOMALIESPAGESIZE = 20; //default page size is kept to 50 for anomaly results
  public static readonly VIDEO_LAG_WAIT_TIME = 300000; //2MINTS WAIT
  public static readonly CLEAR_ALL_CACHE  = AppSettings.DASHBOARD_END_POINT +"/utils/clear-all-cache";
  public static readonly Rect_false  = AppSettings.BaseURL + "auditor/rectified/false";
}
